<template>
  <v-col cols="8" v-if="(bookingDetails.bookingProperties && bookingDetails.bookingProperties.flightInfo)" class="pl-0">
    <v-row no-gutters>
      <v-col
        class="d-flex"
        cols="6"
      >
        <div class="d-flex flex-column" :class="{ 'pl-4': bookingDetails.pricing }">
          <span class="detail-info-title text-uppercase my-2">{{ $t(`components.tripsHistory.expandInfo.flightInfos.title`) }}</span>
          <span class="detail-info-value mb-1" v-if="bookingDetails.bookingProperties.flightInfo.type === 'pickup'"><span v-if="bookingDetails.bookingProperties.flightInfo.airline">{{ bookingDetails.bookingProperties.flightInfo.airline }} - </span>{{ bookingDetails.bookingProperties.flightInfo.number }}</span>
          <span class="detail-info-value mb-1" v-if="bookingDetails.bookingProperties.flightInfo.type === 'pickup'">
            <span v-if="bookingDetails.bookingProperties.flightInfo.type === 'pickup'">{{ $t(`components.tripsHistory.expandInfo.flightInfos.arrivalTime`) }}</span>
            {{ flightTimeLocal }}
          </span>
          <span class="detail-info-value mb-1">{{ $t(`components.tripsHistory.expandInfo.flightInfos.terminal`) }} {{ bookingDetails.bookingProperties.flightInfo.terminal }}</span>
          <span class="detail-info-value mb-1">{{ $t(`components.tripsHistory.expandInfo.flightInfos.passengers`) }} {{ bookingDetails.bookingProperties.flightInfo.totalPassengers }}</span>
          <span class="detail-info-value mb-1">{{ $t(`components.tripsHistory.expandInfo.flightInfos.smallBags`) }} {{ bookingDetails.bookingProperties.flightInfo.totalSmallBags }}</span>
          <span class="detail-info-value mb-1">{{ $t(`components.tripsHistory.expandInfo.flightInfos.largeBags`) }} {{ bookingDetails.bookingProperties.flightInfo.totalLargeBags }}</span>
        </div>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import { time } from '@/helpers/dateTime';

export default {
  name: "flight-info",
  components: {
  },
  mixins: [],
  data() {
    return {
    };
  },
  props: {
    bookingDetails: {
      type: Object,
      required: true,
    },
  },
  methods: {

  },
  computed: {
    flightTimeLocal() {
      if (!this.bookingDetails.bookingProperties.flightInfo.arrivalTimeLocal) {
        return '';
      }
      return time(this.bookingDetails.bookingProperties.flightInfo.arrivalTimeLocal);
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-info-title {
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #888888;
}
.detail-info-value {
  font-size: 12px;
  font-weight: 600;
  line-height: 14.52px;
  letter-spacing: -0.005em;
  text-align: left;
  color: #333333;
}

.detail-info-value_subtext {
  font-size: 12px;
  font-weight: 500;
  line-height: 14.52px;
  letter-spacing: -0.005em;
  text-align: left;
  color: #333333;
}
</style>
